// Mock student data for demonstration
export const mockStudents = [
  {
    id: 'S001',
    name: '張小明',
    englishName: 'Cheung Siu Ming',
    class: '6A',
    studentNumber: '2024001',
    gender: 'male',
    dateOfBirth: '2012-03-15',
    address: '香港九龍灣宏光道123號',
    phone: '2345-1234',
    email: 'cheung.siu.ming@student.school.edu.hk',
    parentName: '張大文',
    parentPhone: '2345-5678',
    parentEmail: 'cheung.tai.man@email.com',
    emergencyContact: '李小明',
    emergencyPhone: '2345-9999',
    enrollmentDate: '2020-09-01',
    status: 'active',
    photo: null,
    notes: '數學成績優秀，需要加強英文學習'
  },
  {
    id: 'S002',
    name: '李小華',
    englishName: 'Lee Siu Wah',
    class: '6A',
    studentNumber: '2024002',
    gender: 'female',
    dateOfBirth: '2012-05-20',
    address: '香港觀塘道456號',
    phone: '2345-1235',
    email: 'lee.siu.wah@student.school.edu.hk',
    parentName: '李大華',
    parentPhone: '2345-5679',
    parentEmail: 'lee.tai.wah@email.com',
    emergencyContact: '王小明',
    emergencyPhone: '2345-9998',
    enrollmentDate: '2020-09-01',
    status: 'active',
    photo: null,
    notes: '美術天賦突出，參加多個藝術比賽'
  },
  {
    id: 'S003',
    name: '王小美',
    englishName: 'Wong Siu Mei',
    class: '6A',
    studentNumber: '2024003',
    gender: 'female',
    dateOfBirth: '2012-07-10',
    address: '香港牛頭角道789號',
    phone: '2345-1236',
    email: 'wong.siu.mei@student.school.edu.hk',
    parentName: '王大美',
    parentPhone: '2345-5680',
    parentEmail: 'wong.tai.mei@email.com',
    emergencyContact: '陳小明',
    emergencyPhone: '2345-9997',
    enrollmentDate: '2020-09-01',
    status: 'active',
    photo: null,
    notes: '音樂成績優秀，鋼琴演奏水平高'
  },
  {
    id: 'S004',
    name: '陳小強',
    englishName: 'Chan Siu Keung',
    class: '6A',
    studentNumber: '2024004',
    gender: 'male',
    dateOfBirth: '2012-09-25',
    address: '香港九龍灣宏光道321號',
    phone: '2345-1237',
    email: 'chan.siu.keung@student.school.edu.hk',
    parentName: '陳大強',
    parentPhone: '2345-5681',
    parentEmail: 'chan.tai.keung@email.com',
    emergencyContact: '劉小明',
    emergencyPhone: '2345-9996',
    enrollmentDate: '2020-09-01',
    status: 'active',
    photo: null,
    notes: '體育成績優秀，田徑隊隊長'
  },
  {
    id: 'S005',
    name: '劉小芳',
    englishName: 'Lau Siu Fong',
    class: '6A',
    studentNumber: '2024005',
    gender: 'female',
    dateOfBirth: '2012-11-30',
    address: '香港觀塘道654號',
    phone: '2345-1238',
    email: 'lau.siu.fong@student.school.edu.hk',
    parentName: '劉大芳',
    parentPhone: '2345-5682',
    parentEmail: 'lau.tai.fong@email.com',
    emergencyContact: '何小明',
    emergencyPhone: '2345-9995',
    enrollmentDate: '2020-09-01',
    status: 'active',
    photo: null,
    notes: '科學成績優秀，參加科學展覽獲獎'
  },
  {
    id: 'S006',
    name: '何小偉',
    englishName: 'Ho Siu Wai',
    class: '6B',
    studentNumber: '2024006',
    gender: 'male',
    dateOfBirth: '2012-01-15',
    address: '香港牛頭角道987號',
    phone: '2345-1239',
    email: 'ho.siu.wai@student.school.edu.hk',
    parentName: '何大偉',
    parentPhone: '2345-5683',
    parentEmail: 'ho.tai.wai@email.com',
    emergencyContact: '黃小明',
    emergencyPhone: '2345-9994',
    enrollmentDate: '2020-09-01',
    status: 'active',
    photo: null,
    notes: '電腦成績優秀，程式設計能力強'
  },
  {
    id: 'S007',
    name: '黃小麗',
    englishName: 'Wong Siu Lai',
    class: '6B',
    studentNumber: '2024007',
    gender: 'female',
    dateOfBirth: '2012-04-20',
    address: '香港九龍灣宏光道147號',
    phone: '2345-1240',
    email: 'wong.siu.lai@student.school.edu.hk',
    parentName: '黃大麗',
    parentPhone: '2345-5684',
    parentEmail: 'wong.tai.lai@email.com',
    emergencyContact: '林小明',
    emergencyPhone: '2345-9993',
    enrollmentDate: '2020-09-01',
    status: 'active',
    photo: null,
    notes: '中文成績優秀，寫作能力強'
  },
  {
    id: 'S008',
    name: '林小傑',
    englishName: 'Lam Siu Kit',
    class: '6B',
    studentNumber: '2024008',
    gender: 'male',
    dateOfBirth: '2012-06-15',
    address: '香港觀塘道258號',
    phone: '2345-1241',
    email: 'lam.siu.kit@student.school.edu.hk',
    parentName: '林大傑',
    parentPhone: '2345-5685',
    parentEmail: 'lam.tai.kit@email.com',
    emergencyContact: '張小明',
    emergencyPhone: '2345-9992',
    enrollmentDate: '2020-09-01',
    status: 'active',
    photo: null,
    notes: '英文成績優秀，口語表達能力強'
  }
];

// Helper function to get students by class
export const getStudentsByClass = (className) => {
  return mockStudents.filter(student => student.class === className);
};

// Helper function to get students by gender
export const getStudentsByGender = (gender) => {
  return mockStudents.filter(student => student.gender === gender);
};

// Helper function to get active students
export const getActiveStudents = () => {
  return mockStudents.filter(student => student.status === 'active');
};

// Helper function to search students by name
export const searchStudentsByName = (searchTerm) => {
  const term = searchTerm.toLowerCase();
  return mockStudents.filter(student => 
    student.name.toLowerCase().includes(term) || 
    student.englishName.toLowerCase().includes(term)
  );
};

// Helper function to get students by enrollment year
export const getStudentsByEnrollmentYear = (year) => {
  return mockStudents.filter(student => {
    const enrollmentYear = new Date(student.enrollmentDate).getFullYear();
    return enrollmentYear === year;
  });
};
